import StatusE from '../../types/statusE'
import { SettingsState } from './stateI'

const initialSettingsState: SettingsState = {
  status: StatusE.IDLE,
}

export default initialSettingsState
